export type IgnoreNominal<T> = Omit<T, '__nominal__'>;
export class BaseModel {
  /** Simulate nominal type */
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  private __nominal__: void;
}
